<template>
	<div>
		<wc-header headerTitle="选择局点" :BackisShow=BackisShow></wc-header>
		<wc-point :style=style></wc-point>
	</div>
</template>

<script>
	export default{
		name: 'Point',
		data(){
			return {
				style:{
					"margin-top":"40px"
				},
				BackisShow:true
			}
		},
		watch:{
			
		},
		methods:{
		},
		mounted(){
			//this.buttonBottom = this.$refs.button.$el.getBoundingClientRect().bottom;
		}
	}
</script>

<style>
	body{
		background: #F3F3F3;
	}
</style>


// WEBPACK FOOTER //
// src/views/point/Point.vue